import camelify from 'camelcase-keys-recursive';

const xhrSendFile = async (url, { file, onUploadProgress }) => new Promise((resolve, reject) => {
  // Create a new XMLHttpRequest
  const xhr = new XMLHttpRequest();
  xhr.open('PUT', url, true);
  xhr.setRequestHeader('Content-Type', file.type);

  // Track upload progress
  xhr.upload.onprogress = (event) => {
    if (event.lengthComputable) {
      onUploadProgress(event);
    }
  };

  // Handle response
  xhr.onload = () => {
    if (xhr.status >= 200 && xhr.status < 300) {
      if (xhr.responseText) {
        const response = JSON.parse(xhr.responseText);
        resolve(response);
      }
      resolve();
    } else {
      reject(new Error('Error uploading file', xhr.statusText));
    }
  };

  xhr.onerror = () => {
    reject(new Error('An error occurred while uploading the file'));
  };

  xhr.send(file);
});

export const uploadFile = async ({ file, signedUrl, onUploadProgress }) => {
  const response = await xhrSendFile(signedUrl, { file, onUploadProgress });
  return camelify(response);
};
